
export default {
    methods: {
        async sendFileS3(path, file) {
            try {
                const formData = new FormData();
                formData.append("id", "1");
                formData.append("path", path);
                formData.append("file", file);

                const response = await axios.post(
                    process.env.MIX_VUE_APP_UPLOAD_URL + `/s3/upload`,
                    formData
                );

                this.isLoading = false;
                return response.data.key; // Corrigido: retorno direto com o valor da chave
            } catch (error) {
                this.isLoading = false;
                this.showErrorMessageWithButton("Ops..", error.response?.data?.error || "Erro ao fazer upload.");
                console.error(error);
                return null;
            }
        },
    }
}